import { ApiRequest, ApiResponse } from "../../../api/types";
export interface ContainerProps {}

export interface ContainerData {}

export interface ContainerComputed {
  planId: number;
  reports: ApiResponse.Reports;
  report: ApiResponse.Report | undefined;
}

export interface ContainerMethods {
  getReports: (params: ApiRequest.GetReports) => void;
  getReport: (params: ApiRequest.GetReport) => void;
}

export interface Data {
  reportHeading: {
    title: string;
    terms: string;
    imgSrc: string;
    imgAlt: string;
  };
  dataArray: object[];
}

export interface Computed {}

export interface Props {
  reports: ApiResponse.Reports;
  report?: ApiResponse.Report;
}

export interface Methods {
  handleClickWeeklySelect: (value: string) => void;
}

export class ReportHeader {
  year: number;
  month: number;
  week: number;
  url: string;
  constructor(data: any) {
    this.year = data.year;
    this.month = data.month;
    this.week = data.week;
    this.url = data.url;
  }

  public isMonthlyReport(): boolean {
    return this.week === 10;
  }
}
